module.exports = __webpack_public_path__ + "img/一堆金币.937940da.png";